import {ValueObject} from '@s-ui/domain'

export class PendingPtaValueObject extends ValueObject {
  /**
   * @param {Number} pendingPta
   */
}
